import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowInTopLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-in-top-left, dock, box, arrow"><path d="M6.75 13.75V21.25H21.25V6.75H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9 9L3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.25 3.75V10.25L3.75 10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowInTopLeft;
